import { createContext, useContext, useState } from "react";

const DialogContext = createContext();

export const DialogProvider = ({ children }) => {
  const [showDialog, setShowDialog] = useState(false);

  return (
    <DialogContext.Provider value={{ showDialog, setShowDialog }}>
      {children}
    </DialogContext.Provider>
  );
};

export const useDialog = () => useContext(DialogContext);
